/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const StarBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m12.278 15.153 2.85 1.72a.15.15 0 0 0 .224-.162l-.756-3.243 2.52-2.184a.15.15 0 0 0-.085-.263l-3.314-.281-1.301-3.07a.15.15 0 0 0-.277 0l-1.3 3.07-3.315.28a.15.15 0 0 0-.085.264l2.52 2.183-.756 3.244a.15.15 0 0 0 .223.163l2.852-1.721Zm-5.166 5.453a.5.5 0 0 1-.745-.541l1.37-5.876-4.564-3.954a.5.5 0 0 1 .285-.876l6.01-.51 2.35-5.544a.5.5 0 0 1 .92 0l2.35 5.544 6.009.51a.5.5 0 0 1 .285.876l-4.564 3.954 1.37 5.876a.5.5 0 0 1-.745.541l-5.165-3.117-5.166 3.117Z" /></svg>);
const Star = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={StarBase} {...rest} ref={ref} />);
export default Star;